<!-- 工作台 -->
<template>
    <div id="login" class="login">
        <div class="mask">
            <div class="login-ctn">
                <div class="introduction">
                    <img src="../../assets/images/logo.png" alt="" />
                    <p>车回佳致力于解决汽车后市场维保服务跟踪与反馈， 建立服务商信用体系平台，实际解决车主需求。 让每一台在路上的车都是最佳状态！</p>
                </div>
                <div class="login-main">
                    <div class="login-title">欢迎登录</div>
                    <el-form :model="subData" :rules="rules" ref="subData">
                        <el-form-item prop="Account" class="login-input">
                            <el-input v-model.trim="subData.Account" placeholder="请输入用户名" v-filter-special-char="subData.Account"> </el-input>
                        </el-form-item>
                        <el-form-item prop="Password" class="login-input">
                            <el-input v-model.trim="subData.Password" placeholder="请输入密码" type="password" v-filter-special-char="subData.Password"> </el-input>
                        </el-form-item>
                        <div class="IsRemember">
                            <el-checkbox v-model="subData.IsRemember">记住密码</el-checkbox>
                        </div>
                        <el-form-item>
                            <el-button class="login-btn btn-primary" round @click="submitForm('subData')">登录</el-button>
                        </el-form-item>
                        <el-form-item>
                            <div class="registered">
                                <span style="color: #8c98cc" @click="forgetPwd">忘记密码</span>
                                <span class="registered-btn" @click="gotoRegistered">—— <span style="color: #8c98cc">注册</span>企业账号 ——</span>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: 'login',
    components: {},
    data() {
        return {
            subData: {
                IsRemember: 0,
                Account: '',
                Password: ''
            },
            rules: {
                Account: [{ required: true, message: '请输入您的账号', trigger: 'blur' }],
                Password: [{ required: true, message: '请输入正确的密码', trigger: 'blur' }]
            }
        };
    },
    mounted() {
        this.getPass();
        document.onkeydown = event => {
            if (this.isLogin) {
                return;
            }
            let e = event || window.event || arguments.callee.caller.arguments[0];
            if (e && e.keyCode == 13) {
                this.submitForm('subData');
            }
        };
        document.title = '车回佳企业客户端管理系统';
    },
    methods: {
        getPass() {
            this.$util
                .axiosGet({
                    url: '/api/Login/GetPassword'
                })
                .then(res => {
                    if (res.data) {
                        this.subData.Account = res.data.Account;
                        this.subData.Password = res.data.Password;
                        this.subData.IsRemember = 1;
                        //以下逻辑已废弃，在路由钩子做了判断，已登录状态下跳到登录页面会去到主页 edit by qdl 2020/7/10
                        // let Token = this.$util.getCookie('Token')
                        // if (Token){
                        //     this.submitForm('subData')
                        // }
                    }
                })
                .catch(() => {});
        },
        // 跳转忘记密码
        forgetPwd() {
            this.$router.push('./forgetPwd');
        },
        // 注册跳转
        gotoRegistered() {
            this.$util.clearLocalStorage('userMsg');
            this.$router.push('/registered/step1');
        },
        // 登录
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.subData.IsRemember = Number(this.subData.IsRemember);
                    this.$util
                        .axiosPost({
                            url: '/api/Login/EntpLogin',
                            data: this.subData
                        })
                        .then(res => {
                            let data = res.data;
                            this.$util.setLocalStorage('userMsg', data);
                            this.$util.setCookie('Token', data.Token, 30 * 24 * 60 * 100);
                            this.isLogin = true;

                            if (this.$util.CHJWinApp) window.location.href = `chjscheme:${encodeURIComponent('login')}`;

                            this.$nextTick(() => {
                                this.$router.push('/');
                            });
                        })
                        .catch(() => {});
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>
.IsRemember {
    text-align: left;
    font-size: @font-xxs;
    margin-bottom: 20px;
}
.registered {
    display: flex;
    justify-content: space-between;
    font-size: @font-xxs;
    span {
        cursor: pointer;
    }
}
.registered-btn {
    cursor: pointer;
}
.login {
    position: relative;
    display: flex;
    flex-direction: column;
    height: calc(100% - 84px) !important;
    background: url('../../assets/images/login-bg.jpg') center;
}
.mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1;
}
.login-ctn {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 800px;
    height: 500px;
    transform: translate(-50%, -50%);
    background: rgba(73, 85, 111, 0.8);
    display: flex;
}
.introduction {
    display: flex;
    flex-direction: column;
    padding: 50px;
    align-items: center;
    width: 55%;
    color: white;
    font-size: @font-md;
    img {
        width: 214px;
        height: 146px;
        margin-bottom: 50px;
    }
    p {
        width: 100%;
        text-indent: 2em;
        line-height: 1.5em;
    }
}
.login-main {
    width: 45%;
    background: white;
    padding: 100px 50px 0;
    text-align: center;
}
.login-title {
    font-size: 24px;
    color: @theme2;
    margin-bottom: 40px;
}
.login-input {
    margin-bottom: 20px;
}
.login-btn {
    background: @theme2;
    color: white;
    width: 100%;
}
</style>
